import React, { useState } from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

import InputField from '../../InputField';
import Menu from '../../Menu';
import MenuItemStatic from '../../Menu/MenuItemStatic';

const isCustomPageValid = (value) => /^\d+$/.test(value);

function MoreButton({ disabled, lastPage, onPageChange, page }) {
  const [customPage, setCustomPage] = useState('');
  const [menuAnchor, setMenuAnchor] = useState();
  const isMenuOpen = Boolean(menuAnchor);

  const handleCustomPageChange = (event) => {
    const updatedCustomPage = event.target.value;
    if (updatedCustomPage && !isCustomPageValid(updatedCustomPage)) {
      return;
    }
    setCustomPage(updatedCustomPage);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      changePage(customPage);
    }
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setCustomPage('');
  };

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const changePage = (updatedPage) => {
    const value = Number(updatedPage);
    if (value && isCustomPageValid(value)) {
      onPageChange(value > lastPage ? lastPage : value);
      setTimeout(() => handleMenuClose(), 0);
    }
  };

  return (
    <>
      <Button
        disabled={disabled}
        size="iconSmall"
        sx={{ margin: '0 -4px' }}
        onClick={handleMenuOpen}
      >
        ...
      </Button>
      <Menu
        anchorEl={menuAnchor}
        open={isMenuOpen}
        MenuListProps={{ 'aria-label': 'More pagination options' }}
        onClose={handleMenuClose}
      >
        <MenuItemStatic>
          <Button
            size="small"
            disabled={disabled || page === 1}
            onClick={() => changePage(1)}
          >
            First page
          </Button>
          {/* For performance issues jump to last page feature is disabled */}

          {/* <Button
            size="small"
            disabled={disabled || page === lastPage}
            onClick={() => changePage(lastPage)}
          >
            Last page
          </Button> */}
        </MenuItemStatic>
        <MenuItemStatic>
          <InputField
            autoFocus
            label="Enter page number"
            size="small"
            value={customPage}
            onChange={handleCustomPageChange}
            onKeyDown={handleKeyDown}
          />
        </MenuItemStatic>
      </Menu>
    </>
  );
}

MoreButton.propTypes = {
  disabled: PropTypes.bool,
  lastPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
};

export default MoreButton;
